import useTestId from '@ori/testid-generator';
import type { FunctionComponent } from 'react';
import { lazy, Suspense } from 'react';

import type { RevieveProps } from '../components';
import { APP_NAME } from '../constants';
import { useConfiguration } from '../contexts';
import { useGetNovageSkincareConfiguration } from '../hooks/useGetNovageSkincareConfiguration';
import { useOpenQueryParam } from '../hooks/useOpenQueryParam';

const Revieve = lazy<FunctionComponent<RevieveProps>>(async () =>
  import('../components/Revieve').then((module) => ({ default: module.Revieve })),
);

export const NovageSkincareAdvisor = () => {
  const novageSkincareConfiguration = useGetNovageSkincareConfiguration();
  const openQueryParam = useOpenQueryParam();
  const { currentLanguage } = useConfiguration();
  const { getTestId } = useTestId();

  return (
    <div data-testid={getTestId(APP_NAME)}>
      <Suspense fallback={null}>
        {novageSkincareConfiguration === undefined ? null : (
          <Revieve
            currentLanguage={currentLanguage}
            novageSkincareConfiguration={novageSkincareConfiguration}
            openQueryParam={openQueryParam}
          />
        )}
      </Suspense>
    </div>
  );
};
